import React, { Component } from "react";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import { ValidationForm, TextInput } from "react-bootstrap4-form-validation";
import swal from "sweetalert";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../../../BaseUrlApi/Url";
import {
  normalizePhoneNumber,
  isValidPhoneNumber,
} from "../../../../utils/phoneNumber";
import {
  apiErrorMessage,
  NURSE_FIELD_LABELS,
} from "../../../../utils/apiError";
import "./AddUser.css";

const headers = {
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  "Content-Type": "application/json",
};

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      immediate: true,
      setFocusOnError: true,
      isSaving: false,
      gender: [],
      choose_gender: {},
      name: "",
      email: "",
      password: "",
      c_password: "",
      startDate: new Date(),
      birthdate: null,
      birthplace: "",
      address: "",
      phonenumber: "",
      // Jenis Kelamin and Tanggal Lahir are react-select/react-datepicker, so
      // they sit outside ValidationForm's checkValidity() pass and need their
      // own error state.
      genderError: null,
      birthdateError: null,
    };
  }
  async componentDidMount() {
    let gender = [
      {
        gender: "male",
        label: "Laki-laki",
      },
      {
        gender: "female",
        label: "Perempuan",
      },
    ];

    let getGender = gender.map((type) => ({
      value: type.gender,
      label: type.label,
    }));

    this.setState({
      gender: getGender,
    });
  }

  selectedDate = (value) => {
    if (this.state.birthdate === null) {
      return "";
    } else {
      return new Date(this.state.birthdate);
    }
  };

  dateHandler = async (date) => {
    this.setState({
      startDate: date,
      birthdateError: null,
    });
    if (date !== null) {
      this.dateConverter(date);
    } else {
      this.setState({ birthdate: null });
    }
  };

  dateConverter = (value) => {
    let date = value,
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    let convertDate = [date.getFullYear(), mnth, day].join("-");
    this.setState({
      birthdate: convertDate,
    });
  };

  inputHandler = async (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  matchPassword = (value) => {
    return value && value === this.state.password;
  };

  validPhoneNumber = (value) => {
    return isValidPhoneNumber(value);
  };

  genderHandler = async (value) => {
    this.setState({
      choose_gender: {
        value: value.value,
        label: value.label,
      },
      genderError: null,
    });
  };

  saveUser = async (e) => {
    e.preventDefault();

    // ValidationForm has already cleared the text inputs at this point; the
    // two custom widgets still need checking.
    const genderError = this.state.choose_gender.value
      ? null
      : "Jenis kelamin harus dipilih";
    const birthdateError = this.state.birthdate
      ? null
      : "Tanggal lahir harus diisi";

    if (genderError || birthdateError) {
      this.setState({ genderError, birthdateError });
      swal({
        title: "GAGAL",
        text: [genderError, birthdateError].filter(Boolean).join("\n"),
        icon: "warning",
        buttons: "OK",
      });
      return;
    }

    const datas = {
      name: this.state.name,
      email: this.state.email,
      password: this.state.password,
      c_password: this.state.c_password,
      gender: this.state.choose_gender.value,
      birthdate: this.state.birthdate,
      birthplace: this.state.birthplace,
      phone_number: normalizePhoneNumber(this.state.phonenumber),
      address: this.state.address,
    };

    if (datas.password !== datas.c_password) {
      swal({
        title: "GAGAL",
        text: "Password tidak sama",
        icon: "warning",
        buttons: "OK",
      });
      return;
    }

    this.setState({ isSaving: true });
    try {
      await axios.post(`${API_URL}/admin/users/nurseRegister`, datas, {
        headers,
      });
      const move = await swal({
        title: "Sukses!",
        text: "Data Perawat Telah Berhasil Ditambahkan!",
        icon: "success",
        button: "OK",
      });
      if (move) {
        window.location.href = `/users`;
      }
    } catch (err) {
      swal({
        title: "GAGAL",
        text: apiErrorMessage(err, NURSE_FIELD_LABELS),
        icon: "warning",
        buttons: "OK",
      });
    } finally {
      this.setState({ isSaving: false });
    }
  };

  render() {
    return (
      <div>
                <div className="content-section">
          <div className="title-section mb-5">
            <h1 className="patient-page-title">Manajemen Pengguna</h1>
            <h2 className="patient-page-subtitle">
              <span style={{ color: "#039BEB" }}>Manajemen Pengguna</span>
              <span style={{ color: "#00000029" }}> / Daftar Perawat</span>
            </h2>
          </div>
          <div className="card shadow mb-4">
            <div className="card-body text-left">
              <ValidationForm
                onSubmit={this.saveUser}
                ref={this.formRef}
                immediate={this.state.immediate}
                setFocusOnError={this.state.setFocusOnError}
              >
                <table cellPadding="10" className="add-table ml-3">
                  <tbody>
                    <tr>
                      <td colSpan="2">
                        <p className="account-title">Data Akun</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Email
                        </label>
                      </td>
                      <td>
                        
                        :
                        <TextInput
                          type="email"
                          name="email"
                          required
                          errorMessage={{
                            required: "Email harus diisi",
                            type: "Format email tidak valid",
                          }}
                          onChange={this.inputHandler}
                          className="add-vaccine-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Nama
                        </label>
                      </td>
                      <td>
                        
                        :
                        <TextInput
                          type="text"
                          name="name"
                          required
                          errorMessage={{ required: "Nama harus diisi" }}
                          onChange={this.inputHandler}
                          className="add-vaccine-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Password
                        </label>
                      </td>
                      <td>
                        
                        :
                        <TextInput
                          type="password"
                          name="password"
                          required
                          errorMessage={{ required: "Password harus diisi" }}
                          onChange={this.inputHandler}
                          className="add-vaccine-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Re-Password
                        </label>
                      </td>
                      <td>
                        
                        :
                        <TextInput
                          type="password"
                          name="c_password"
                          required
                          successMessage="Password diterima!"
                          errorMessage={{
                            required: "Confirm password is required",
                            validator: "Password tidak sama",
                          }}
                          onChange={this.inputHandler}
                          validator={this.matchPassword}
                          className="add-vaccine-input"
                        />
                      </td>
                    </tr>

                    {/* PRIVATE DATA SECTION */}
                    <tr>
                      <td colSpan="2">
                        <br />
                        <p className="account-title">Data Pribadi</p>
                      </td>
                    </tr>
                    <tr className="selector">
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Jenis Kelamin
                        </label>
                      </td>
                      <td className="add-fam-selector">
                        <span style={{ margin: "1.5rem 2rem 0 0" }}> : </span>
                        <Select
                          options={this.state.gender}
                          value={
                            this.state.choose_gender.value
                              ? this.state.choose_gender
                              : null
                          }
                          onChange={(value) => this.genderHandler(value)}
                          className="select-selector"
                          placeholder="Pilih jenis kelamin..."
                        />
                        {this.state.genderError && (
                          <div className="text-danger small mt-1">
                            {this.state.genderError}
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Tempat Lahir
                        </label>
                      </td>
                      <td>
                        
                        :
                        <TextInput
                          type="text"
                          name="birthplace"
                          required
                          errorMessage={{
                            required: "Tempat lahir harus diisi",
                          }}
                          onChange={this.inputHandler}
                          className="add-vaccine-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Tanggal Lahir
                        </label>
                      </td>
                      <td>
                        
                        :
                        <DatePicker
                          selected={this.selectedDate()}
                          onChange={this.dateHandler}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="dd-mm-yyyy"
                          showYearDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                        />
                        {this.state.birthdateError && (
                          <div className="text-danger small mt-1">
                            {this.state.birthdateError}
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          Alamat
                        </label>
                      </td>
                      <td>
                        
                        :
                        <TextInput
                          type="text"
                          name="address"
                          required
                          errorMessage={{ required: "Alamat harus diisi" }}
                          onChange={this.inputHandler}
                          className="add-vaccine-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="" className="add-vaccine-label">
                          No. Telp
                        </label>
                      </td>
                      <td>
                        
                        :
                        {/* Deliberately type="tel", not type="number": a
                            number input blanks its own value for anything
                            that isn't a valid float, so "+62 812-3456-7890"
                            read back as an empty string while the box still
                            looked filled. */}
                        <TextInput
                          type="tel"
                          name="phonenumber"
                          required
                          errorMessage={{
                            required: "No. telp harus diisi",
                            validator:
                              "Nomor WhatsApp tidak valid. Contoh: 081234567890",
                          }}
                          validator={this.validPhoneNumber}
                          onChange={this.inputHandler}
                          className="add-vaccine-input"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
                <div className="patient-buttons">
                  <button
                    type="submit"
                    className="btn btn-primary mr-1"
                    disabled={this.state.isSaving}
                  >
                    {this.state.isSaving ? "Menyimpan..." : "Simpan"}
                  </button>
                  <Link to="/users">
                    <button type="button" className="btn btn-danger mr-1">
                      Batal
                    </button>
                  </Link>
                </div>
              </ValidationForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddUser;
